import React, { type ComponentProps, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import './page-content.scss';

function PageContentLayout(
  props: React.PropsWithChildren & ComponentProps<'div'>,
) {
  return <div className={cn('page', props.className)}>{props.children}</div>;
}

function PageContentLayoutHeader(
  props: React.PropsWithChildren & {
    buttons?: ReactNode;
  } & ComponentProps<'div'>,
) {
  return (
    <div className={cn('page-header', props.className)}>
      {props.children}
      <div className="page-header__buttons">{props.buttons}</div>
    </div>
  );
}

function PageContentLayoutSubheader(
  props: React.PropsWithChildren & ComponentProps<'div'>,
) {
  return (
    <div className={cn('page-subheader', props.className)}>
      {props.children}
    </div>
  );
}

function PageContentLayoutMain(
  props: React.PropsWithChildren & ComponentProps<'div'>,
) {
  return (
    <div className={cn('page-main', props.className)}>{props.children}</div>
  );
}

export {
  PageContentLayout,
  PageContentLayoutHeader,
  PageContentLayoutSubheader,
  PageContentLayoutMain,
};
